<template>
  <div v-if="product" class="stripe_payment">
    <div class="secured">
      <div class="grid">
        <img id="lock" src="/assets/icons/lock.png" /> <span>Paiement sécurisé par </span
        ><img src="/assets/icons/stripe.png" />
      </div>
    </div>
    <div v-show="status === 0" class="box">
      <div>
        <div v-if="ready && hasExistingPaymentMethod" class="section">
          <label for="useexisting">
            <input id="useexisting" v-model="useexisting" :value="true" type="radio" />Utiliser un moyen de paiement
            existant</label
          >
        </div>

        <div v-if="hasExistingPaymentMethod && useexisting" class="section methodForm">
          <div class="cardlist">
            <select v-model="selectedCard" class="cardSelect">
              <option v-for="(elt, i) in existing_methods" :key="`card${i}${elt}`" :value="elt">{{
                methodName(elt)
              }}</option>
            </select>
            <button class="bouton" @click.prevent="removeCard">Oublier {{ selectedMethod }}</button>
          </div>
        </div>

        <div v-if="ready && hasExistingPaymentMethod" class="section">
          <label for="newpay" class="section">
            <input id="newpay" v-model="useexisting" :value="false" type="radio" />Utiliser un nouveau moyen de
            paiement</label
          >
        </div>

        <div id="payment-element" class="methodForm section" v-show="ready && !useexisting"></div>

        <div class="methodForm section" v-show="ready">
          <div class="total">
            <div>
              {{ product.name }}: <strong>{{ formatPrice(sale.price, sale.product.currency) }}</strong>
            </div>
          </div>

          <div class="boutons">
            <a
              id="submit"
              href="#"
              class="bouton payer"
              :disabled="!readyToPay"
              :class="{ disabled: !valid && !useexisting }"
              @click="submitPayment"
            >
              Procéder au paiement
            </a>
          </div>

          <div class="cheque">
            <p>Si vous souhaitez régler par chèque ou par virement bancaire, cliquez sur le bouton ci-dessous</p>
            <router-link
              v-if="product"
              :to="{ name: 'Check', query: { id: product.id } }"
              class="bouton"
              @click.prevent="cheque"
              >Paiement par Chèque ou Virement Bancaire</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 10" id="loading" class="box">*** Paiement en cours ***</div>

    <div v-show="status === 1" id="refuse" class="box">
      <p><strong>Votre paiement n'a pas été accepté par la banque :(</strong></p>
      <p>
        L'erreur retournée est : <strong>{{ this.error }}</strong>
      </p>

      <p>Vous pouvez contacter Idylive si le problème persiste</p>
      <div class="boutons">
        <button class="bouton retour tryagain" href="#" @click.prevent="tryAgain">Réessayer</button>
      </div>
    </div>

    <div v-show="status === 2" class="box">
      <p><strong>Idylive vous remercie pour votre confiance. </strong></p>
      <p></p>
    </div>

    <div v-if="status === 3" class="box">
      <p><strong>Idylive vous remercie pour votre confiance.</strong></p>

      <p>
        Vous avez choisi un moyen de paiement dont la validation n'est pas instantanée. Votre Pass Idylive sera activé
        dans quelques jours dés que votre paiement sera validé. N'hésitez pas à nous contacter si votre Pass n'est
        toujours pas actif après une semaine.
      </p>
    </div>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { timeout } from "../../assets/js/idyu/util";
import { idyuJsonRpc } from "../../assets/js/idyu/connect";
import { idyuFormatPrice } from "@/assets/js/idyu/util.js";

export default {
  beforeRouteEnter(to, from, next) {
    next(async function(vm) {
      let sale = null;

      try {
        const product = await idyuJsonRpc("getProduct", parseInt(to.query.id));
        const idSale = await idyuJsonRpc("createSales");
        sale = await idyuJsonRpc("initSales", idSale, "st", product.id);
      } catch {
        return;
      }
      if (!sale) {
        return;
      }

      vm.product = sale.product;
      vm.sale = sale;
      vm.status = 0;
      vm.existing_methods = [];
      vm.selectedCard = null;
      vm.valid = false;
      vm.ready = false;

      if (to.params.sepa) {
        vm.sepa = true;
      } else {
        vm.sepa = false;
      }

      let cards = await idyuJsonRpc("getCards");
      vm.existing_methods = cards.filter(elt => {
        if (vm.sepa) {
          return elt.bank_code != null;
        } else {
          return elt.bank_code == null;
        }
      });

      if (vm.hasExistingPaymentMethod) {
        vm.useexisting = true;
        vm.selectedCard = vm.existing_methods[0];
      } else {
        vm.useexisting = false;
      }

      vm.stripe = await loadStripe(vm.apipk);

      vm.initForm();
    });
  },

  data() {
    return {
      ready: false,
      link: null,
      useexisting: true,
      valid: false,
      sale: null,
      error: null,
      product: null,
      card: null,
      selectedCard: null,
      existing_methods: null,
      status: 0,
      stripe: null,
      elements: null,
      sepa: false,
      style: {
        base: {
          color: "#32325d",
          fontFamily: "Arial, sans-serif",
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#32325d"
          }
        }
      }
    };
  },

  computed: {
    secret() {
      try {
        return this.sale.paymentMethod.clientSecret;
      } catch {
        return null;
      }
    },

    hasExistingPaymentMethod() {
      return this.existing_methods.length >= 1;
    },

    apipk() {
      if (process.env.NODE_ENV === "production") {
        return "pk_live_QmPNXiHWi2GdebrTsdl0Vq7V00AzhUd7H8";
        // return "pk_test_7vmchQYOIML7ihOyKHoBVdm400VvGKbOvO";
      } else {
        return "pk_test_7vmchQYOIML7ihOyKHoBVdm400VvGKbOvO";
      }
    },

    readyToPay() {
      return this.valid || (this.useexisting && this.selectedCard != null);
    },

    selectedMethod() {
      if (!this.selectedCard) {
        return "";
      }
      if (this.selectedCard.expiry) {
        return "Carte";
      }
      return "RIB/IBAN";
    }
  },

  methods: {
    formatPrice(price, cur) {
      return idyuFormatPrice(price, cur);
    },

    async removeCard() {
      if (this.selectedCard != null) {
        if (await confirm("Etes-vous sûr(e) de vouloir oublier ce(tte) " + this.selectedMethod + "?")) {
          let res = await idyuJsonRpc("forgetCard", this.selectedCard.id);
          if (res == false) {
            await alert("Impossible d'oublier cette carte, veuillez contacter Idylive");
          } else {
            let ind = this.existing_methods.findIndex(
              card => this.selectedCard != null && card.id == this.selectedCard.id
            );
            this.existing_methods.splice(ind, 1);
            if (this.hasExistingPaymentMethod == false) {
              this.useexisting = false;
            }
          }
        }
      }
    },

    methodName(elt) {
      if (!elt) {
        return "";
      }
      if (elt.expiry) {
        return `Carte finissant par : ${elt.last4}, expiration : ${elt.expiry}`;
      }
      return `IBAN avec code Banque : ${elt.bank_code} finissant par : ${elt.last4}`;
    },

    tryAgain() {
      if (this.elements) {
        this.elements.getElement("payment").clear();
        this.valid = false;
        this.status = 0;
      }
    },

    async submitPayment() {
      if (this.stripe && this.sale && this.secret) {
        if (this.readyToPay) {
          this.status = 10;
          let result = null;

          if (this.useexisting == true) {
            if (!this.selectedCard) {
              throw "No selected card";
            }
            if (this.selectedCard.expiry != null) {
              result = await this.stripe.confirmCardPayment(this.secret, {
                payment_method: this.selectedCard.id
              });
            }
            if (this.selectedCard.bank_code != null) {
              result = await this.stripe.confirmSepaDebitPayment(this.secret, {
                payment_method: this.selectedCard.id
              });
            }
          } else {
            if (this.elements) {
              const sere = this.product.type == 1 ? "#sere" : "";
              let port = "";
              if (window.location.port != null && window.location.port != "80") {
                port = `:${window.location.port}`;
              }
              result = await this.stripe.confirmPayment({
                elements: this.elements,
                redirect: "if_required",
                confirmParams: {
                  return_url:
                    `${window.location.protocol}//${window.location.hostname}${port}` + `/v3/confirmation${sere}`
                }
              });
            }
          }

          if (result == null || (result.error && !result.paymentIntent)) {
            this.status = 1;
            this.error = result.error.message || "Payment refused";
          } else {
            switch (result.paymentIntent.status) {
              case "succeeded": {
                await timeout(2000);
                if (this.product.type == 1) {
                  window.location = `/v3/confirmation#sere?payment_intent=${result.paymentIntent.id}`;
                } else {
                  window.location = `/v3/confirmation?payment_intent=${result.paymentIntent.id}`;
                }

                break;
              }

              case "processing": {
                await timeout(2000);
                window.location = "/v3/confirmation";
                // this.status = 3;
                break;
              }

              default: {
                this.status = 1;
              }
            }
          }
        }
      }
    },

    initForm() {
      if (this.stripe && this.sale && this.secret) {
        const appearance = {
          theme: "stripe"
        };
        this.elements = this.stripe.elements({ appearance, clientSecret: this.secret });
        let order = ["card", "sepa_debit"];
        if (this.sepa) {
          order = ["sepa_debit", "card"];
        }
        const paymentElement = this.elements.create("payment", {
          paymentMethodOrder: order,
          terms: {
            card: "never"
          }
        });

        paymentElement.on("change", event => {
          if (event.complete) {
            if (event.complete) {
              this.valid = true;
            }
          }
        });

        paymentElement.on("ready", () => {
          this.ready = true;
        });

        paymentElement.mount("#payment-element");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.secured {
  padding-top: 10px;
}

.secured .grid {
  font-size: 20px;
  font-weight: bold;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  grid-gap: 10px;
  align-items: center;
  span {
    margin-top: 5px;
  }
  img {
    max-height: 30px;
  }
}
.stripe_payment {
  font-size: 16px;
}

.stripe_payment #loading {
  font-size: 18px;
  text-align: center;
}

.methodForm {
  position: relative;
  font-size: 16px;
  h3 {
    margin-bottom: 20px;
    #lock {
      width: 25px;
      vertical-align: middle;
    }
  }
}

.stripe_payment .total {
  text-align: right;
  position: relative;
}

.stripe_payment .payer {
  margin-top: 10px;
  position: relative;
  width: auto;
  padding-left: 5px;
  padding-right: 5px;
}

.stripe_payment .annuler {
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 14px;
  text-decoration: underline;
}

.stripe_payment .bandeau {
  position: relative;
}

.stripe_payment .cadenas {
  float: right;
  margin-top: 3px;
}

.stripe_payment h2 {
  color: #5b80a9;
  font-size: 20px;
}

.stripe_payment .retour {
  width: auto;
  padding-left: 5px;
  padding-right: 5px;
}

.stripe_payment p {
  text-align: justify;
}

.stripe_payment .cardElement {
  border: 1px #ccc solid;
  padding: 5px;
}

.cardSelect {
  width: auto;
}

.cardlist {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 10px;
}
.remove {
  margin-top: 10px;
}

.section {
  margin-top: 10px;
}

.cheque {
  margin-top: 10px;
}
.cheque a {
  max-width: 500px;
}

#submit {
  color: white;
  background-color: #0c4da1;
}
</style>
